// Conversation Box Animation
function animateConversationBoxes(section) {
    if (!section) return;
    
    // Check for reduced motion preference
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    const conversationBoxes = section.querySelectorAll('.conversation-box');
    
    conversationBoxes.forEach((box, index) => {
        // For reduced motion, show all boxes immediately without animation
        if (prefersReducedMotion) {
            box.style.transform = 'translateX(0)';
            box.style.opacity = '1';
            box.style.transition = 'none';
            return;
        }
        
        // Mobile-friendly smaller offset and faster timing
        const isMobile = window.innerWidth <= 768;
        const offset = isMobile ? '15px' : '30px';
        const duration = isMobile ? '0.5s' : '0.8s';
        const delay = isMobile ? index * 100 : index * 200; // Faster delays on mobile
        
        // Reset and position boxes with subtle offset
        box.style.transform = index % 2 === 0 ? `translateX(-${offset})` : `translateX(${offset})`;
        box.style.opacity = '0';
        box.style.transition = `transform ${duration} ease-out, opacity ${duration} ease-out`;
        
        // Animate each box with a slight delay
        setTimeout(() => {
            box.style.transform = 'translateX(0)';
            box.style.opacity = '1';
        }, delay);
    });
}

// Reset animation when section loses visible-section class
function resetConversationBoxes(section) {
    if (!section) return;
    
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const conversationBoxes = section.querySelectorAll('.conversation-box');
    
    conversationBoxes.forEach((box, index) => {
        // For reduced motion, don't reset to hidden state
        if (prefersReducedMotion) {
            box.style.opacity = '1';
            box.style.transform = 'translateX(0)';
            box.style.transition = 'none';
            return;
        }
        
        // Mobile-friendly offset
        const isMobile = window.innerWidth <= 768;
        const offset = isMobile ? '15px' : '30px';
        
        // Reset to initial hidden state with subtle offset
        box.style.transform = index % 2 === 0 ? `translateX(-${offset})` : `translateX(${offset})`;
        box.style.opacity = '0';
        box.style.transition = 'none'; // No transition for reset
    });
}

// Mutation Observer to watch for class changes
function setupConversationAnimation() {
    // Create Mutation Observer to watch for class changes
    const mutationObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                const section = mutation.target;
                
                if (section.classList.contains('visible-section')) {
                    // Section became visible, trigger animation
                    animateConversationBoxes(section);
                } else {
                    // Section lost visible-section class, reset animation
                    resetConversationBoxes(section);
                }
            }
        });
    });

    // Observe all rbsv2-content-content sections for class changes
    const sections = document.querySelectorAll('.rbsv2-content-content-section');
    sections.forEach(section => {
        mutationObserver.observe(section, {
            attributes: true,
            attributeFilter: ['class']
        });
    });
}

// Intersection Observer to add/remove visible-section class
function setupIntersectionObserver() {
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Add the visible-section class
                entry.target.classList.add('visible-section');
            } else {
                // Remove the visible-section class when not intersecting
                entry.target.classList.remove('visible-section');
            }
        });
    }, {
        threshold: 0.2, // Trigger when 20% of the section is visible (better for mobile)
        rootMargin: '0px 0px -100px 0px' // Start animation earlier on mobile devices
    });

    // Observe all rbsv2-content-content sections
    const sections = document.querySelectorAll('.rbsv2-content-content-section');
    sections.forEach(section => {
        intersectionObserver.observe(section);
    });
}

// Initialize everything when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
    setupConversationAnimation();
    setupIntersectionObserver();
});

// Also check for sections that might already be visible (in case of fast loading)
window.addEventListener('load', () => {
    const visibleSections = document.querySelectorAll('.rbsv2-content-content-section.visible-section');
    visibleSections.forEach(section => {
        animateConversationBoxes(section);
    });
});
